// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import CodeSvg from '@rsuite/icon-font/lib/file/Code';
var Code = createSvgIcon({
  as: CodeSvg,
  ariaLabel: 'code',
  category: 'file',
  displayName: 'Code'
});
export default Code;